import React, { Component } from "react";
import AboutUsDescription from "./AboutUsDescription";

class AboutUs extends Component {
  state = {
    link: "",
  };

  componentDidMount() {
    let link = this.props.match.params.link;
    this.setState({
      link: link,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.link != this.props.match.params.link) {
      let link = this.props.match.params.link;
      this.setState({
        link: link,
      });
    }
  }

  render() {
    return (
      <div>
        <AboutUsDescription type={this.state.link} />
      </div>
    );
  }
}

export default AboutUs;
